export function buildSEOImageUrl(rawImageUrl: string): string {
  if (!rawImageUrl) return "";

  const match = rawImageUrl.match(/\/o\/(.*?)\?/);
  if (!match) return rawImageUrl;

  const decoded = decodeURIComponent(match[1]);
  const parts = decoded.split("/");
  const folder = parts[0];
  const file = parts[parts.length - 1];

  const safe = file
    .replace(/\s+/g, "-")
    .replace(/[()"]/g, "")     // ❌ do NOT remove apostrophes anymore
    .replace(/-+/g, "-");

  return `https://img.illusbook.com/${folder}/${safe}`;
}
